<template>
  <div>
    <div style="display: flex; margin-bottom: 20px; margin-left: 40px">
      <el-page-header @back="back" content="打印入库单" style="margin-right: 20px"></el-page-header>
      <button type="primary" @click="printContext">打印</button>
    </div>
    <div id="printMe" ref="print">
        <div class="table_title">{{ tenantName }} (入库单)</div>
        <!-- 打印 -->
        <div>
          <div class="AMarkUl">
            <ul>
              <li>货主：{{ dataJson.huozhu }}</li>
              <li>编号：{{ dataJson.danhao }}</li>
            </ul>
            <ul>
              <li>车牌号：转货</li>
              <li>入库日期：{{ dataJson.shijian.slice(0, 10) }}</li>
              <li>仓库电话：18910908040</li>
            </ul>
          </div>
          <table style="word-break:break-all;word-wrap:break-all;">
            <tbody>
              <tr>
                <td class="kunbao" rowspan="2">序号</td>
                <td class="kunbao" style="min-width:75px" rowspan="2">品名</td>
                <td class="kunbao" rowspan="2">规格</td>
                <td class="kunbao" rowspan="2">材质</td>
                <td class="kunbao" rowspan="2">产地</td>
                <td class="kunbao" rowspan="2">发货单位</td>
                <td class="kunbao" colspan="2">实收货量</td>
                <td class="kunbao" rowspan="2">货物</td>
                <td class="kunbao" rowspan="2">备注</td>
              </tr>
               <tr>
                <td class="kunbao">件数(件)</td>
                <td class="kunbao">重量(T)</td>
              </tr>
              <tr v-for="(item1, index1) in tableList" :key="index1">
                 <td class="">{{ index1+1 }}</td>
                <td class="">{{ item1.productTypeName }}</td>
                <td class="">{{ item1.specification }}</td>
                <td class="">{{ item1.model }}</td>
                <td class="">{{ item1.steelMillName }}</td>
                <td class=""></td>
                <td class="">{{item1.number }}</td>
                <td class="">{{ item1.allWeight }}</td>
                <td class=""></td>
                <td class=""></td>
              </tr>
              <tr>
                <td colspan="6">合计</td>
                <td>{{ dataJson.allNumber }}</td>
                <td>{{  dataJson.allWeight}} </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div class="AMarkFoot">
            <ul>
              <li>开票员：{{ username }}</li>
              <li>货主(经办人)签名：</li>
              <li>保管员：</li>
            </ul>
          </div>
          <div class="remarks">
            注：本入库单所记载的货物规格、材质、产地、重量均摘自产品标识牌所记载的内容。
          </div>
          <div style="   text-align: right;">
           <p>{{ tenantName }}</p>
           <p>{{ dizhi }}</p>
           <p>（预留印鉴）</p>
           <p>{{ datenow }}</p>
          </div>

        </div>

    </div>
  </div>
</template>

<script>
import { getTEmptyChangeDetailList } from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { dateFormat1 } from '@/utils/util'

export default {
  data () {
    return {
      tenantName: localStorage.getItem('tenantName'),
      datenow: '',
      dataJson: {},
      tableList: []
    }
  },
  created () {
    // 生命周期里接收参数
    this.dataJson = this.$route.query// 接受参数关键代码
    this.username = window.localStorage.getItem('userName')
    this.datenow = dateFormat1(new Date().getTime(), 'CHN')
    this.getTEmptyChangeDetailList()
    let code = window.localStorage.getItem('tenantCode')
    if (code == '02m') {
      this.dizhi = '中远海运物流北京房山库（北京市房山区阎村镇炒米店村西北金港物流园)'
    } else if (code == '01E') {
      this.dizhi = '中远海运物流北京念头西库（北京市昌平区农辛路）'
    } else if (code == '0E6') {
      this.dizhi = '中远海运物流北京念头火运库（北京市昌平区水南路99号）'
    } else if (code == '0EL') {
      this.dizhi = '中远海运物流石家庄智慧库（石家庄市鹿泉区京赞线169号河北省智慧物流产业园区B#库市内第6、7、8跨。）'
    } else if (code == '0KL') {
      this.dizhi = '中远海运物流北京顺义库 北京市顺义区李桥镇钢钢好钢铁物流产业园'
    } else if (code == '0KK') {
      this.dizhi = '中远海运唐山乐钢库（唐山市乐亭经济开发区北海路与烟台道交叉口）'
    } else {
      this.dizhi = '中远海运唐山京唐库（河北省唐山市乐亭县 海港开发区海富路与港滨南街交叉口）'
    }
  },
  mounted () {
  },
  methods: {
    // 打印内容
    printContext () {
      this.$print(this.$refs.print)
    },
    // 点击返回上一步
    back () {
      this.$router.go(-1) // 返回上一层
    },
    // 出库计划-主数据-打印
    getTEmptyChangeDetailList () {
      getTEmptyChangeDetailList({
        changeId: this.dataJson.changeId, // 出库主表id
        pageNo: 1,
        pageSize: 100
      }).then((res) => {
        this.dataJson.allNumber = res.all.allNumber
        this.dataJson.allWeight = res.all.allWeight
        this.tableList = res.pageInfo.list
        // this.list = res
        // res.forEach((item, index) => {
        //   console.log(item, '11111')
        //   item.tWhOutstockMaster.weightSum = ''
        //   item.tWhOutstockMaster.numberSum = ''
        //   item.tWhOutstockMaster.GBweight = ''
        //   item.tWhOutstockMaster.weightSum = item.list.reduce((pre, cur) => Number(pre / 1 + cur.allWeight / 1).toFixed(3), 0)
        //   item.tWhOutstockMaster.numberSum = item.list.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
        //   item.tWhOutstockMaster.GBweight = item.list.reduce((pre, cur) => Number(pre / 1 + cur.weighingWeight / 1).toFixed(3), 0)
        // })
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    }

  }

}
</script>

<style scoped lang='less'>
button {
  width: 100px !important;
}

#printMe {
  font-size: 16px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  border: 1px solid #ccc;

  .table_title {
    width: 100%;
    height: 40px;
    font-size: 28px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}

.printtable {
  width: 800px;
  margin-bottom: 20px;
}

.AMarkUl {
  // font-size: 12px !important;
  width: 100%;
  font-size: 14px;

  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;

    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}

.AMarkFoot {
  font-size: 14px;
  bottom: 10px;
  width: 100%;

  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;

    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}

table,
th,
td {
  border: 1px solid blue;
}

table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 1px solid black;
}

table {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 16px;

  td {
    // width: 17%;
    // padding: 4px 4px;
    text-align: center;
    height: 24px;
  }

  .kunbao {
    font-weight: 600;
  }
}

.remarks {
  font-size: 12px;

  p {
    margin: 0;
    padding: 0;
  }
}
</style>
